import { Component, type ReactNode } from 'react'

type Props = {
  children: ReactNode
  fallback?: (error: Error, reset: () => void) => ReactNode
}

type State = { error: Error | null }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: unknown) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught:', error, info)
  }

  reset = () => this.setState({ error: null })

  render() {
    if (this.state.error) {
      if (this.props.fallback) {
        return this.props.fallback(this.state.error, this.reset)
      }
      return (
        <div className="error-boundary" role="alert">
          <div style={{ fontSize: 48, marginBottom: 12 }}>⚠️</div>
          <h2>Qualcosa è andato storto</h2>
          <p className="muted" style={{ marginBottom: 4 }}>
            {this.state.error.message || 'Errore inaspettato durante il rendering.'}
          </p>
          <p className="muted" style={{ fontSize: 'var(--fs-11)' }}>
            Riprova. Se persiste, ricarica la pagina o contatta supporto IT.
          </p>
          <div
            style={{
              display: 'flex',
              gap: 8,
              justifyContent: 'center',
              marginTop: 16,
            }}
          >
            <button type="button" className="btn" onClick={this.reset}>
              Riprova
            </button>
            <button
              type="button"
              className="btn primary"
              onClick={() => window.location.reload()}
            >
              Ricarica pagina
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
